<template>
  <!-- 预览表格数据 -->
  <div class="my_meterReading_detail">
    <van-nav-bar :title="'预览数据'"
                 left-text=""
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true">
    </van-nav-bar>
    <!-- 保存loading -->
    <div class="table_box"
         style="overflow: auto;">
      <table ref="table"
             class="table">
        <!-- 表头 -->
        <tr class="top">
          <th v-for="(item_th, index_th) in tableHeadList"
              :key="index_th">
            <div class="title"
                 :style=" item_th.gridwidth  ? { width: item_th.gridwith * 1.5 + 'px' } : 'min-width:90px' ">
              {{ item_th.chnname }}
            </div>
          </th>
        </tr>
        <!--展示列表数据 -->
        <tr class="cont"
            v-for="(item_tr, index_tr) in tableData"
            :key="index_tr">
          <td v-for="(item_td, index_td) in tableHeadList"
              :key="index_td">
            <div class="comm_box">
              <div>{{ item_tr[item_td.fieldname] }}</div>
            </div>
          </td>
        </tr>
        <tr class="nodata"
            v-if="tableData.length == 0">
          <td align="center"
              :colspan="tableHeadList.length + 1">
            暂无数据
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import * as imageConversion from 'image-conversion'
import { getWxFixDormCost, saveWxFixDormCost } from "@api/wx.js";
export default {
  data () {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {};
    return {
      userInfo,    
      tableHeadList: [],
      tableData: [],
      checkedIdx: 0,
      ordata:{}
    }
  },
  created () {
    const v = sessionStorage.getItem('jxWhenMyAssesListDetailTableData')
    if (v) {
      this.ordata = JSON.parse(v)
      this.tableHeadList = this.ordata.fieldlist      
      this.tableData = this.ordata.datalist
    }else{
      this.$router.push('/jxWhenMyAssesListDetail')
    }
  },
  methods: {
    // 返回
    onClickLeft () {
     this.$router.push('/jxWhenMyAssesListDetail')
    }
  }

}
</script>

<style lang="less" scoped>
.my_meterReading_detail {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  .van-nav-bar {
    background: #2b8df0;
    z-index: 99;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .query_box {
    height: 120px;
    padding: 20px;
    display: flex;
    background: #ffffff;
    .room_box {
      width: 50%;
      display: flex;
      align-items: center;
      border-left: 2px solid;
      .van-cell {
        font-size: 32px;
        padding: 10px 20px;
        /deep/.van-cell__title {
          font-weight: bold;
          color: #333333;
        }
        /deep/.van-cell__value {
          .van-field__body {
            .van-field__control {
            }
          }
        }
      }
      .van-cell::after {
        border: unset;
      }
    }
    .yymm_box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      .yearMon {
        margin: 0 10px;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  .table_box {
    margin-top: 40px;
    height: calc(100% - 40px);
    .table {
      width: 100%;
      border-spacing: 0px;
      tr {
        td:nth-child(1) {
          border-left: 2px solid #dcdfe6;
        }
        th,
        td {
          padding: 6px 10px;
          text-align: center;
          border-bottom: 2px solid #dcdfe6;
          border-right: 2px solid #dcdfe6;
          .comm_box {
            display: flex;
            justify-content: center;
            .boolean_box {
              .van-checkbox {
                justify-content: center;

                /deep/.van-checkbox__icon--checked {
                  .van-icon {
                    color: #fff !important;
                    background-color: #1989fa !important;
                    border-color: #1989fa !important;
                  }
                }

                /deep/.van-checkbox__icon--disabled .van-icon {
                  background-color: #fff;
                }
              }
            }
            .input_box {
              width: 150px;
              .van-cell {
                font-size: 24px;
                border: 2px solid #d2d2d2;
                border-radius: 10px;
                padding: 8px 16px;
              }
            }
          }
        }
      }
      .top {
        position: sticky;
        top: 0;
        font-size: 28px;
        background: #e9f3fd;
        height: 64px;
        th:nth-child(1) {
          border-left: 2px solid #dcdfe6;
        }
        th {
          border-top: 2px solid #dcdfe6;
        }
      }
      .cont {
        height: 64px;
        font-size: 24px;
        .upload_box {
          display: flex;
          align-items: center;
          justify-content: center;
          /deep/.van-uploader {
            .van-uploader__wrapper {
              .van-uploader__preview {
                margin: 0;
              }
            }
          }
        }
      }
      .cont:nth-child(2n-1) {
        background: #f5f5f5;
      }
      .nodata {
        td {
          font-size: 28px;
        }
      }
    }
  }
  .btn_box {
    height: 110px;
    display: flex;
    align-items: center;
    padding: 20px;
    background: #ffffff;
    .btn {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex: 1;
      .van-button {
        width: 60%; // 40%;
        font-size: 32px;
        padding: 10px 0;
        border-radius: 20px;
      }
    }
  }
}
</style>